import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './pagination.module.less';

const Pagination = ({ pages, current, generateUrl, onClick }) => {
  // Previous link
  let prev = '';
  if (current > 1) {
    prev = (
      <a
        href={generateUrl(current - 1)}
        className={styles.prevnext}
        onClick={onClick ? e => onClick(e, current - 1) : null}
        title="Previous page"
      >
        <Icon name="left" />
      </a>
    );
  }

  // Next link
  let next = '';
  if (current < pages) {
    next = (
      <a
        href={generateUrl(current + 1)}
        className={styles.prevnext}
        onClick={onClick ? e => onClick(e, current + 1) : null}
        title="Next page"
      >
        <Icon name="right" />
      </a>
    );
  }

  // If more than 11 pages, need ellipses
  let leftEllipses = null;
  let rightEllipses = null;
  if (pages > 11) {
    if (current > 5) {
      leftEllipses = <span key="left-ellipses">&hellip;</span>;
    }
    if (pages - current > 5) {
      rightEllipses = <span key="right-ellipses">&hellip;</span>;
    }
  }

  let links = [];
  for (let i = 1; i <= pages; i++) {
    // One of the pages that is skipped by the ellipses
    if (leftEllipses && i > 2 && i < current - 2) {
      continue;
    }
    if (rightEllipses && i > 5 && i > current + 2 && i <= pages - 2) {
      continue;
    }

    // Add the right ellipses
    if (rightEllipses && i === pages - 1) {
      links.push(rightEllipses);
    }

    // The actual page link
    links.push(
      <a
        key={i}
        href={generateUrl(i)}
        className={i === current ? styles.active : ''}
        onClick={onClick ? e => onClick(e, i) : null}
        title={'Page ' + i}
      >
        {i}
      </a>
    );

    // Add the left ellipses
    if (leftEllipses && i === 2) {
      links.push(leftEllipses);
    }
  }

  return (
    <div className={styles.pagination}>
      {prev}
      <div className={styles.links}>{links}</div>
      {next}
    </div>
  );
};

Pagination.displayName = 'Pagination';
Pagination.propTypes = {
  /** Number of total pages */
  pages: PropTypes.number.isRequired,
  /** Current page (starts at 0) */
  current: PropTypes.number.isRequired,
  /** Function that takes a page number and returns a URL */
  generateUrl: PropTypes.func.isRequired,
  /** Function that takes an event and page number */
  onClick: PropTypes.func,
};
Pagination.defaultProps = {
  generateUrl: () => '#',
};

export default Pagination;
